import { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import MenuContext from "@menu/core/menu.context";
import DictionaryHelper from "@menu/core/dictionary";
import { AnalyticsType, getAnalyticTags } from "@menu/core/lib";

type SearchProps = {
    context: MenuContext,
    onClose: any
}

const Search = observer((props: SearchProps) => {
    const defaultSearchPage = "search";
    const { context, onClose } = props;
    const searchInputRef = useRef<any>();
    const [searchValue, setSearchValue] = useState<string>("");

    const dictionary = DictionaryHelper.dictionary;

    const searchPageName = context.config.searchPageName || defaultSearchPage;
    const searchRoot = context.siteUrl + searchPageName;

    const closeSearch = (e: any) => {
        clearSearch(e);
        onClose();
    }

    useEffect(() => {
        if (!context.displaySearch) {
            return;
        }

        searchInputRef.current.focus();

    }, [context.displaySearch]);

    if (!context.displaySearch) {
        return null;
    }

    const clearSearch = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        setSearchValue("");
    }

    const closeAnalytics = getAnalyticTags({
        component_name: "search_close",
        nav_item: AnalyticsType.topLevel,
        nav_text: "search",
        target_page_url: "_self"
    });

    const clearAnalytics = getAnalyticTags({
        component_name: "search_clear_btn",
        nav_item: AnalyticsType.topLevel,
        nav_text: "search_clear",
        target_page_url: "_self"
    });

    const buttonAnalytics = getAnalyticTags({
        component_name: "search_btn",
        nav_item: AnalyticsType.search,
        nav_text: searchValue,
        target_page_url: "_self"
    });

    const hasSearchValue = searchValue?.length ?? 0;
    const clearCssClassName = hasSearchValue ? "icon-close" : "";

    return (
        <form method="get" action={searchRoot} className="menu-search">
            <i
                className="icon-close"
                {...closeAnalytics}
                onClick={closeSearch} />
            <span className="menu-search-container">
                <span className="search-input-container">
                    <input
                        ref={searchInputRef}
                        id="search"
                        name="search"
                        type="text"
                        autoComplete="off"
                        placeholder={dictionary.searchPlaceholder}
                        value={searchValue}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                        }}
                    />
                    <span
                        className={clearCssClassName}
                        {...clearAnalytics}
                        onClick={clearSearch}></span>
                </span>

                <button
                    type="submit"
                    {...buttonAnalytics}>{dictionary.searchNow}</button>
            </span>
        </form>
    );
});

export default Search;